import React from 'react';
import { components } from 'react-select';
import { Box } from '../../../Box/Box';
import { Text } from '../../../Text/Text';

export const NoOptionsMessage = props => {
  const { children } = props;

  return (
    <Box display="flex" alignItems="center" justifyContent="center" height={48}>
      <components.NoOptionsMessage {...props}>
        <Text fontWeight={500} color="neutral.500">
          {children}
        </Text>
      </components.NoOptionsMessage>
    </Box>
  );
};
